module.exports = __webpack_public_path__ + "img/homeBanner.ee156f51.png";